import type { BoundActions } from 'react-sweet-state';
import { fg } from '@atlassian/jira-feature-gating';
import { fetchGoalsByFuzzyName, type Node } from '../../../../services/goals';
import type { StoreApi, ContainerProps, LazyGoal, State } from '../types';
import { transformToGoal } from '../utils';

export const actions = {
	fetchGoalsByFuzzyName:
		(searchString: string) =>
		async ({ getState, setState }: StoreApi, { cloudId }: ContainerProps) => {
			const { lazyGoalsByARI: prevLazyGoalsByARI } = getState();

			setState({
				searchesInProgress: getState().searchesInProgress + 1,
			});

			fetchGoalsByFuzzyName(searchString, cloudId)
				.then((goalNodes: Node[]) => {
					const goals = goalNodes.map(transformToGoal);

					const lazyGoalsByARI = goals.reduce<Record<string, LazyGoal>>(
						(acc, goal) => {
							acc[goal.id] = { isLoading: false, goal };
							return acc;
						},
						fg('plan_timeline_sort_goal_groups_alphabetically')
							? { ...prevLazyGoalsByARI }
							: prevLazyGoalsByARI,
					);

					setState({
						lazyGoalsByARI,
					});
				})
				.catch(() => {
					// error already logged previously
				})
				.finally(() => {
					const { searchesInProgress } = getState();
					setState({
						searchesInProgress: searchesInProgress - 1,
					});
				});
		},
	resetError:
		() =>
		({ setState }: StoreApi) => {
			setState({
				isError: false,
			});
		},
};

export type BoundActionsType = BoundActions<State, typeof actions>;
